'use client';
import React, { useState, useEffect, ReactNode } from 'react';
import H5BottomTabs from '../H5BottomTabs';
import './index.scss';
import { useNavListSwitch, usePanelHeight, useSearchOpen } from './hooks';

interface ItemProps {
    prefixCls: string;
    title: ReactNode;
    itemId?: string;
    children?: ReactNode;
}

interface EfWebNavListProps {
    prefixCls: string;
    SearchPanel?: ReactNode;
    children: React.ReactElement<ItemProps>[];
}

const EfWebNavListItem: React.FC<ItemProps> = ({ title }) => {
    return <div>{title}</div>;
};

const EfWebNavList: React.FC<EfWebNavListProps> & {
    Item: typeof EfWebNavListItem;
} = ({ prefixCls, children, SearchPanel }) => {
    // 面板动画
    const { height, contentRef } = usePanelHeight();
    // 搜索面板状况
    const { open: openSearch } = useSearchOpen();
    // 中间导航切换逻辑
    const { activeIndex, lineStyle, handleClickEnter, handleMouseEnter, handleMouseLeave, handleMouseLeaveTab, itemRefs, tabLineRef } = useNavListSwitch();

    const activeChild = activeIndex !== null ? children[activeIndex] : null;

    // 拿到准确的 header 高度
    const [headerHeight, setHeaderHeight] = useState(45);
    useEffect(() => {
        const header = document.querySelector('.ecoflow-frame-header');
        if (header) {
            setHeaderHeight(header.clientHeight);
        }
    }, []);
    return (
        <div className={`${prefixCls}-nav-list`} onMouseLeave={handleMouseLeave}>
            <div className={`${prefixCls}-nav-list__content`}>
                {React.Children.map(children, (child, idx) => (
                    <div
                        key={idx}
                        className={`${prefixCls}-nav-list__navItem ${activeIndex === idx ? 'active' : ''}`}
                        onMouseEnter={() => handleMouseEnter(idx)}
                        onMouseLeave={() => handleMouseLeaveTab()}
                        onClick={() => handleClickEnter(idx)}
                    >
                        <div
                            className={`${prefixCls}-nav-list__navItem-title`}
                            // @ts-ignore
                            ref={(el) => (itemRefs.current[idx] = el)}
                        >
                            {child.props.title}
                        </div>
                    </div>
                ))}

                <div
                    className={`${prefixCls}-nav-list__bottom-line ${activeIndex !== null ? 'open' : ''}`}
                    style={{
                        opacity: lineStyle.opacity,
                        transform: `translateX(${lineStyle.left}px)`,
                        width: `${lineStyle.width}px`,
                    }}
                    ref={tabLineRef}
                ></div>

                <H5BottomTabs />
            </div>

            <div
                className={`${prefixCls}-nav-list__dropdown ${openSearch ? 'search__dropdown' : ''} ${activeIndex !== null || openSearch ? 'open' : ''}`}
                style={{ height }}
            >
                <div ref={contentRef}>
                    {/* 导航栏内容 */}
                    {activeChild?.props.children}
                    {/* 搜索面板 */}
                    {/* <div className={`${prefixCls}-search-content ${!activeChild && openSearch ? 'show' : ''}`}>{SearchPanel}</div> */}
                    {!activeChild && openSearch && SearchPanel}
                </div>
            </div>

            {/* 阴影 */}
            <div
                className={`${prefixCls}-nav-list__mask ${activeIndex !== null || openSearch ? 'open' : ''}`}
                // @ts-ignore
                style={{ '--web-header-height': `${headerHeight}px` }}
            ></div>
        </div>
    );
};

EfWebNavList.Item = EfWebNavListItem;
export default EfWebNavList;
